import React from 'react';
import { Chip } from '@billda/design-system';

interface SubGroupSectionProps {
  icon: React.ComponentType<{ className?: string }>;
  name: string;
  count: number;
  onTextClick?: () => void;
  secondaryText?: React.ReactNode;
  children: React.ReactNode;
}

export const SubGroupSection = React.memo(function SubGroupSection({
  icon: Icon,
  name,
  count,
  onTextClick,
  secondaryText,
  children,
}: SubGroupSectionProps) {
  const labelContent = (
    <>
      <Icon className="size-4 shrink-0 text-content-secondary" />
      <span className="type-body-lg truncate font-medium transition-colors duration-150 group-hover/subgroup:text-content-accent">
        {name}
      </span>
    </>
  );

  return (
    <div data-testid="sub-group-section">
      {/* Sub-group header row — full-width hover */}
      <div className="hover:bg-surface-raised flex min-h-10 w-full items-center gap-2 py-1 pl-8 pr-3 sm:pl-10">
        {onTextClick ? (
          <button
            type="button"
            onClick={onTextClick}
            className="group/subgroup flex min-w-0 cursor-pointer items-center gap-2 rounded-sm border-0 bg-transparent p-0 text-left focus-visible:outline-2 focus-visible:outline-border-focused"
          >
            {labelContent}
          </button>
        ) : (
          <div className="flex min-w-0 items-center gap-2">{labelContent}</div>
        )}
        {count > 1 && <Chip label={count} size="sm" variant="outlined" />}
        {secondaryText && (
          <>
            <div className="flex-1" />
            {secondaryText}
          </>
        )}
      </div>

      {/* Children — always visible */}
      {children}
    </div>
  );
});
